import React from 'react';
import { Sparkles, BookHeart } from 'lucide-react';
export function Vision() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <div className="bg-brand-bg rounded-3xl p-8 md:p-12 shadow-sm border border-brand-sage/20 relative overflow-hidden" data-id="element-84">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 text-brand-sage/10" data-id="element-85">
            <Sparkles className="w-32 h-32" data-id="element-86" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-brand-textDark mb-6 relative z-10" data-id="element-87">
            Imagina por un momento que...
          </h2>

          <p className="text-lg md:text-xl text-brand-text leading-relaxed mb-8 relative z-10" data-id="element-88">
            En lugar de terminar el día agotada, con culpa o pensando "otra vez
            reaccioné mal", pudieras entender qué necesita realmente tu hijo y
            responder de una forma que{' '}
            <strong className="text-brand-sageDark" data-id="element-89">
              fortalezca el vínculo entre ustedes.
            </strong>
          </p>

          <div className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative z-10" data-id="element-90">
            <div className="bg-brand-sage/10 p-4 rounded-full shrink-0" data-id="element-91">
              <BookHeart className="w-8 h-8 text-brand-sageDark" data-id="element-92" />
            </div>
            <div data-id="element-93">
              <h3 className="text-xl font-bold text-brand-textDark mb-2" data-id="element-94">
                Eso es exactamente lo que encontrarás dentro del Mega Pack
                Crianza con Calma.
              </h3>
              <p className="text-brand-text" data-id="element-95">
                No son teorías difíciles ni consejos imposibles de aplicar. Es
                una guía práctica, clara y pensada para madres y padres reales
                que quieren disfrutar más de la crianza sin sentirse
                desbordados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}